var SuiNumber = /** @class */ (function () {
    function SuiNumber(number) {
        this.number = 0;
        this.number = number;
    }
    SuiNumber.getDecimalLength = function (number) {
        var str = number.toString().split(".")[1];
        if (str) {
            return str.length;
        }
        return 0;
    };
    SuiNumber.getMaxPowed = function (num1, num2) {
        var dLength1 = SuiNumber.getDecimalLength(num1);
        var dLength2 = SuiNumber.getDecimalLength(num2);
        var maxDLength = Math.max(dLength1, dLength2);
        return Math.pow(10, maxDLength);
    };
    SuiNumber.prototype.multipe = function (number) {
        var maxPowed = SuiNumber.getMaxPowed(this.number, number);
        this.number =
            (Math.round(this.number * maxPowed) * Math.round(number * maxPowed)) /
                Math.pow(maxPowed, 2);
        return this;
    };
    SuiNumber.prototype.divide = function (number) {
        var maxPowed = SuiNumber.getMaxPowed(this.number, number);
        this.number =
            Math.round(this.number * maxPowed) / Math.round(number * maxPowed);
        return this;
    };
    SuiNumber.prototype.plus = function (number) {
        var maxPowed = SuiNumber.getMaxPowed(this.number, number);
        this.number =
            (Math.round(this.number * maxPowed) + Math.round(number * maxPowed)) /
                maxPowed;
        return this;
    };
    SuiNumber.prototype.minus = function (number) {
        var maxPowed = SuiNumber.getMaxPowed(this.number, number);
        this.number =
            (Math.round(this.number * maxPowed) - Math.round(number * maxPowed)) /
                maxPowed;
        return this;
    };
    return SuiNumber;
}());
export { SuiNumber };
/**
 * 四舍五入
 * @param value
 * @param n
 */
export function roundFun(value, n) {
    if (n === void 0) { n = 4; }
    var powed = Math.pow(10, n);
    return Math.round(new SuiNumber(value).multipe(powed).number) / powed;
}
/**
 * 判断字符串是不是纯数字
 * @param str
 */
export function isNumberString(str) {
    return /^\d+$/.test(str);
}
/**
 * 补齐小数
 * @example toFixed(1,2) => 1.00
 * @param value 需要处理的数字
 * @param n 补齐的小数位数
 */
export function toFixed(value, n) {
    if (n === void 0) { n = 2; }
}
/**
 * 将数字转为金钱格式
 * @example formatMoney(1000000, 2) => 1,000,000.00
 * @param value 需要处理的数字
 * @param n 需要展示小数点后几位
 */
export function formatMoney(value, n) {
    if (n === void 0) { n = 0; }
    var str = value.toString().split(".");
    var int = str[0];
    var decimal = str[1] || "";
    int = int.replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
    if (n) {
        if (n > decimal.length) {
            decimal += Array(n - decimal.length)
                .fill(0)
                .join("");
        }
        else {
            decimal = decimal.slice(0, n);
        }
        return int + "." + decimal;
    }
    else {
        return int;
    }
}
/**
 * 保留N位小数，余下的无条件进位
 * @example 提款剩余流水
 * @param value 需要处理的数字
 * @param n 需要展示小数点后几位
 */
export function toCeil(value, n) {
    if (n === void 0) { n = 2; }
    var powed = Math.pow(10, n);
    return Math.ceil(new SuiNumber(value).multipe(powed).number) / powed;
}
/**
 * 保留N位小数，余下的无条件舍去
 * @example 投注输赢明细
 * @param value 需要处理的数字
 * @param n 需要展示小数点后几位
 */
export function toFloor(value, n) {
    if (n === void 0) { n = 2; }
    var powed = Math.pow(10, n);
    return Math.floor(new SuiNumber(value).multipe(powed).number) / powed;
}
